import type { ReactElement } from 'react';
import type { EntityTypeDto } from '@gr/core/content/entities/dto';
import { Link, useT } from '../../../../app/di';
import { Badge } from '../../../../ui-kit/Badge/Badge';
import { Button } from '../../../../ui-kit/Button/Button';
import { EmptyState } from '../../../../ui-kit/EmptyState/EmptyState';
import styles from './EntityTypeList.module.scss';

export interface EntityTypeListProps {
  blogId: string;
  types: readonly EntityTypeDto[];
  pending: boolean;
  onEdit(type: EntityTypeDto): void;
  onDelete(type: EntityTypeDto): void;
}

/** ENT-UC-1…3: справочники блога с полями и числом записей. */
export function EntityTypeList({ blogId, types, pending, onEdit, onDelete }: EntityTypeListProps): ReactElement {
  const { t, tp } = useT();
  if (types.length === 0) return <EmptyState title={t('entities.types.empty')} text={t('entities.types.emptyText')} />;
  return (
    <ul className={styles.list}>
      {types.map((type) => (
        <li key={type.id} className={styles.item}>
          <div className={styles.info}>
            <div className="u-row">
              <Link to="entities" params={{ blogId, typeId: type.id }}>
                <strong>{type.pluralName}</strong>
              </Link>
              <Badge>{tp('entities.types.countPlural', type.entityCount)}</Badge>
            </div>
            <span className="u-muted u-small">{type.fields.map((f) => f.label).join(', ')}</span>
          </div>
          <div className="u-row">
            <Button size="sm" icon="edit" onClick={() => onEdit(type)}>
              {t('common.edit')}
            </Button>
            <Button size="sm" variant="ghost" icon="trash" disabled={pending} onClick={() => onDelete(type)}>
              {t('common.delete')}
            </Button>
          </div>
        </li>
      ))}
    </ul>
  );
}
